import { fetcher } from '@commenda/utils';

export interface LinkAdminPylonAccountParams {
  companyId: number;
  pylonAccountId: string;
}

export interface LinkAdminPylonAccountResponse {
  success: boolean;
}

export async function linkAdminPylonAccount({
  companyId,
  pylonAccountId,
}: LinkAdminPylonAccountParams): Promise<LinkAdminPylonAccountResponse> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/pylon/link`,
    {
      method: 'POST',
      body: { pylonAccountId },
    }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to link Pylon account';
    throw new Error(message);
  }

  return response.json();
}
